/** @format */
//@ts-nocheck
import { notification } from "antd";
import React, { CSSProperties, ReactNode } from "react";
import { UIButton } from "../components/ui/Button";

const notificationStyle = {
  borderRadius: "7px",
  whiteSpace: "break-spaces",
};

const notificationStyleXL: CSSProperties = {
  borderRadius: "7px",
  whiteSpace: "break-spaces",
  scale: "1.5",
  marginTop: "20px",
};

const notificationStyleErrorBig: CSSProperties = {
  borderRadius: "7px",
  whiteSpace: "break-spaces",

  width: "50vw",        // tutta la larghezza viewport
  maxWidth: "50vw",

  marginTop: "0px",

  left: 0,               // importantissimo
  right: 0,              // importantissimo

  background: "#fff1f0",        // rosso molto chiaro (Ant Design error bg)
  border: "1px solid #ffccc7",  // bordo rosso soft

  color: "#a8071a",             // testo rosso scuro leggibile
  padding: "80px 24px",
};

export const showNotification = (
  type: "error" | "warning" | "success" | "notification",
  message: string | ReactNode,
  description: string | ReactNode,
  duration?: number = 3,
  style?: "M" | "XL" | "error_big" = "M",
  placement?: "top" | "bottom" | "topLeft" | "topRight" | "bottomLeft" | "bottomRight" = "topRight",
): void => {

  if(notification){
    notification.destroy();
  }

  const options = {
    message,
    description,
    style: style == "M" ? notificationStyle : (style == "XL" ? notificationStyleXL : notificationStyleErrorBig),
    duration,
    placement,
  };
  switch (type) {
    case "error":
      notification.error({ ...options });
      break;
    case "warning":
      notification.warn({ ...options });
      break;
    case "success":
      notification.success({ ...options });
      break;
    case "notification":
      notification.open({ ...options });
      break;
    default:
      notification.open({ ...options });
      break;
  }
};

export const showNotificationWithButton = (
  type: "error" | "warning" | "success" | "notification",
  message: string,
  description: string | React.ReactNode,
  style?: "M" | "XL" = "M",
  placement?: "top" | "bottom" | "topLeft" | "topRight" | "bottomLeft" | "bottomRight" = "topRight",
): void =>{
  const key = `open${Date.now()}`;
  const options = {
      message,
      description,
      duration: 0,
      style: style == "M" ? notificationStyle : notificationStyleXL,
      placement,
      key,
      btn: <UIButton type="primary" size="small" onClick={() => notification.close(key)}>Chiudi</UIButton>
    };
    switch (type) {
      case "error":
        notification.error({ ...options });
        break;
      case "warning":
        notification.warn({ ...options });
        break;
      case "success":
        notification.success({ ...options });
        break;
      case "notification":
        notification.open({ ...options });
        break;
      default:
        notification.open({ ...options });
        break;
    }
}
